export const gibAirRate = (state) => state.gibAirRate;
